export default __webpack_public_path__ + "images/de43ebd5732356aa520dbb423c5a53fa-dark_theme.png";